import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { AnalyticEvents } from '@app/enums';
import { Pagination } from '@app/interfaces';
import { Company } from '@app/models/company/company.model';
import { Employee } from '@app/models/employee/employee.model';
import { AddEmployeesTable } from '@app/modules/self-serve/services/tables/add-employees/add-employees.table';
import { MenuColumnEvent } from '@app/modules/table/interfaces/menu-column-event.interface';
import { AnalyticService, AuthService, NotifyService } from '@app/services';
import { TranslateService } from '@ngx-translate/core';

@Component({
    templateUrl: './add-employees.template.html',
    styleUrls: ['../../../self-serve.style.scss'],
    styles: [
        `
            :host {
                --card-bottom-margin: 0;
                --table-background-color: transparent;
            }
        `,
    ],
})
export class AddEmployeesView implements OnInit {
    @ViewChild('form', { static: true }) form!: NgForm;
    isLoading = true;
    company: Company = new Company();
    table: AddEmployeesTable | undefined;
    addedEmployeeCount = 0;

    constructor(
        private analyticService: AnalyticService,
        private router: Router,
        private notifyService: NotifyService,
        private translateService: TranslateService,
        private authService: AuthService
    ) {}

    ngOnInit(): void {
        this.table = new AddEmployeesTable(this.authService, this.translateService);
        this.loadData();
    }

    menuAction(event: MenuColumnEvent<Employee>): void {
        const { menuItem, data } = event;
        if (!data) {
            return;
        }

        switch (menuItem.event) {
            case 'edit':
                this.analyticService.trackEvent(AnalyticEvents.SelfServeAddEmployeeClickEditEmployee);

                // add query param
                this.router.navigate(['employees/directory', data.id, 'personal']);
                break;
        }
    }
    private async loadData(): Promise<void> {
        this.isLoading = true;

        try {
            const [[, employeeMeta], [onboardingEmployees, _], company]: [
                [unknown, { pagination: Pagination }],
                [Employee[], unknown],
                Company,
            ] = await Promise.all([
                Employee.param('company', this.authService.company.id).limit(1).get(),
                Employee.param('company', this.authService.company.id).where('status', 'onboarding').all(),
                Company.find(this.authService.company.id),
            ]);

            // we subtract 1 because we don't want to count the current user
            this.addedEmployeeCount = employeeMeta.pagination.total - 1;
            this.company = company;
        } catch (error) {
            this.notifyService.error(error);
        } finally {
            this.isLoading = false;
        }
    }
}
